import locations from './locations.json';

export const MIN_PLAYERS = 2;
export const MAX_PLAYERS = 20;
export const MAX_NAME_LENGTH = 30;
export const categories = [
  { id: 'Kuwait', label: 'أماكن الكويت' },
  { id: 'Kuwaiti-Shows', label: 'مسلسلات كويتية' },
  { id: 'Soccer-Players', label: 'لاعبين كرة القدم' },
  { id: 'Fatayer', label: 'فطاير' },
  { id: 'Saudi-Celebrities', label: 'مشاهير سعوديين' },
  { id: 'Movies', label: 'أفلام' },
  { id: 'Celebrities', label: 'مشاهير عالميين' },
  { id: 'Animals', label: 'حيوانات' },
];
export const normalizeName = (name) => name.trim().replace(/\s+/g, ' ');

export function nameError(name, players) {
  const normalized = normalizeName(name);
  if (!normalized) return 'nameRequired';
  if (normalized.length > MAX_NAME_LENGTH) return 'nameTooLong';
  if (players.length >= MAX_PLAYERS) return 'playersFull';
  if (players.some(player => player.name.normalize('NFKC').toLocaleLowerCase() === normalized.normalize('NFKC').toLocaleLowerCase())) return 'duplicateName';
  return null;
}

export function createInitialState() {
  return {
    phase: 'setup', players: [], category: categories[0].id, nextId: 1,
    round: null, viewedIds: [], openPlayerId: null, usedLocations: {},
  };
}

// Randomness stays outside the reducer so StrictMode cannot assign a round twice.
export function createRound(state, random = Math.random) {
  if (state.players.length < MIN_PLAYERS || state.players.length > MAX_PLAYERS) return null;
  const choices = locations[state.category];
  if (!choices) return null;
  let used = state.usedLocations[state.category] || [];
  let available = choices.filter(item => !used.includes(item.name));
  if (!available.length) {
    used = [];
    available = choices;
  }
  const spyId = state.players[Math.floor(random() * state.players.length)].id;
  const location = available[Math.floor(random() * available.length)];
  return {
    spyId, location, category: state.category,
    usedLocations: { ...state.usedLocations, [state.category]: [...used, location.name] },
  };
}

export function gameReducer(state, action) {
  switch (action.type) {
    case 'addPlayer':
      if (state.phase !== 'setup' || nameError(action.name, state.players)) return state;
      return { ...state, nextId: state.nextId + 1, players: [...state.players, { id: state.nextId, name: normalizeName(action.name) }] };
    case 'removePlayer':
      return state.phase === 'setup' ? { ...state, players: state.players.filter(player => player.id !== action.id) } : state;
    case 'selectCategory':
      return state.phase === 'setup' && categories.some(category => category.id === action.category) ? { ...state, category: action.category } : state;
    case 'start':
      if (state.phase !== 'setup' || state.players.length < MIN_PLAYERS || !action.round) return state;
      return { ...state, phase: 'reveal', round: action.round, usedLocations: action.round.usedLocations, viewedIds: [], openPlayerId: null };
    case 'showRole':
      if (state.phase !== 'reveal' || state.openPlayerId !== null || state.viewedIds.includes(action.id) || !state.players.some(player => player.id === action.id)) return state;
      return { ...state, openPlayerId: action.id };
    case 'concealRole':
      // Switching apps or locking the phone hides the role without marking it read.
      return { ...state, openPlayerId: null };
    case 'finishReveal': {
      if (state.phase !== 'reveal' || state.openPlayerId === null) return state;
      const viewedIds = [...state.viewedIds, state.openPlayerId];
      return { ...state, openPlayerId: null, viewedIds, phase: viewedIds.length === state.players.length ? 'active' : 'reveal' };
    }
    case 'end':
      return state.phase === 'active' ? { ...state, phase: 'ended' } : state;
    case 'playAgain':
      return state.phase === 'ended' ? { ...state, phase: 'setup', round: null, viewedIds: [], openPlayerId: null } : state;
    default:
      return state;
  }
}
